var React = require('react');

function NounLever2176903Inline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard 15"),React.createElement("path",{"d":"M86,80H76A27.7937,27.7937,0,0,0,44.01,52.3182L31.4646,30.5875l1.7307-.9993a2,2,0,0,0,.7324-2.7324L25.9277,13a2.0021,2.0021,0,0,0-2.7324-.7324l-6.9277,4A2,2,0,0,0,15.5352,19l8,13.8555a2.0011,2.0011,0,0,0,2.7324.7324l1.7324-1L39.9023,53.2047A28.0419,28.0419,0,0,0,20,80H10a2,2,0,0,0,0,4H86a2,2,0,0,0,0-4ZM26,29.1234,20,18.7328l3.4629-2,6,10.3906ZM36,80a12,12,0,1,1,24,0ZM48,64A16.0184,16.0184,0,0,0,32,80H24a24,24,0,0,1,48,0H64A16.0184,16.0184,0,0,0,48,64Z","key":1})]);
}

NounLever2176903Inline.defaultProps = {"viewBox":"0 0 96 96","x":"0px","y":"0px"};

module.exports = NounLever2176903Inline;

NounLever2176903Inline.default = NounLever2176903Inline;
